/* esm.sh - applesauce-core@5.2.0/dist/models/profile */
export * from "/*applesauce-core@5.2.0/esnext/dist/models/profile.mjs";
